<template>
  <div class="disclaimer-section">
    <v-form ref="form">
      <div v-if="agreementText" class="agreement-text">
        <h4 class="agreement-title">
          I have read, understand fully, and agree to the content of this form.
        </h4>
      </div>

      <div v-if="!agreementText" class="disclaimer-content">
        <div class="disclaimer-header">
          <h3 class="disclaimer-title">Disclaimer</h3>
        </div>
        
        <div class="disclaimer-text">
          <p class="disclaimer-description">
            To the best of my knowledge, the questions on this form have been
            accurately answered. I understand that providing incorrect
            information can be dangerous to my (or patient's) health. It is my
            responsibility to inform the dental office of any changes in medical
            status.
          </p>
        </div>

        <div class="form-row">
          <div class="form-group">
            <v-select
              v-model="relationshipToPatient"
              :items="relationshipToPatientItems"
              :rules="[rules.required]"
              label="Relationship to Patient *"
              class="line-input custom-filled"
              dense
              hide-details="auto" />
          </div>

          <div class="form-group" v-if="relationshipToPatient !== 'Self'">
            <v-text-field
              v-model="nameIfNotPatient"
              :rules="[rules.required, rules.max25]"
              label="Name if not Patient *"
              class="line-input custom-filled"
              dense
              hide-details="auto" />
          </div>
        </div>
      </div>

      <div class="signature-section">
        <div v-if="!agreementText" class="signature-label">
          Patient or Guardian Signature <span class="required-asterisk">*</span>
        </div>
        
        <div class="signature-pad-container">
          <VueSignaturePad
            :options="{onBegin: () => {$refs.signaturePad.resizeCanvas()}}"
            id="signature"
            class="signature-pad"
            width="100%"
            height="200px"
            ref="signaturePad" />
        </div>
        
        <div class="signature-actions">
          <v-btn class="btn-secondary" @click="clearSignature()">CLEAR</v-btn>
        </div>
      </div>
    </v-form>
  </div>
</template>
<script>
import DataService from '../../../_services/DataService';
import ValidateService from '../../../_services/ValidateService';
import Vue from 'vue';
import VueSignaturePad from 'vue-signature-pad';
Vue.use(VueSignaturePad);

export default {
  name: 'Disclaimer',
  props: ['agreementText'],
  data() {
    return {
      clientName: '',
      relationshipToPatient: '',
      nameIfNotPatient: '',
      relationshipToPatientItems: ['Self', 'Spouse', 'Parent / Guardian'],
      rules: ValidateService.validators,
    };
  },
  methods: {
    async clearSignature() {
      this.$refs.signaturePad.clearSignature();
    },
    async validate() {
      let valid = this.$refs.form.validate();
      if (!valid) {
        return valid;
      }

      // validate signature
      const { isEmpty } = this.$refs.signaturePad.saveSignature();
      if (isEmpty) {
        // alert not valid
        let alert = {
          color: 'error',
          text: 'Please sign the form.',
        };
        this.$root.$emit('raise_alert', alert);
        return isEmpty;
      }
      return valid;
    },
  },
  async mounted() {
    const { name } = await DataService.getClientDetails();
    this.clientName = name;
  },
};
</script>
<style lang="scss" scoped>
@import '@/scss/variables.scss';

// Form-specific color variables
$disclaimer-bg: #f8fafc;
$disclaimer-border: #e2e8f0;
$agreement-title-color: #374151;
$disclaimer-title-color: #1f2937;
$disclaimer-description-color: #4b5563;
$signature-label-color: #374151;
$required-asterisk-color: #dc2626;
$signature-pad-border: #d1d5db;
$signature-pad-bg: white;

.disclaimer-section {
  margin-top: 32px;
  padding: 24px;
  background: $disclaimer-bg;
  border: 1px solid $disclaimer-border;
  border-radius: 12px;
}

.agreement-text {
  text-align: center;
  margin-bottom: 24px;
  
  .agreement-title {
    font-size: 16px;
    font-weight: 600;
    color: $agreement-title-color;
    margin: 0;
  }
}

.disclaimer-content {
  .disclaimer-header {
    text-align: center;
    margin-bottom: 16px;
    
    .disclaimer-title {
      font-size: 18px;
      font-weight: 600;
      color: $disclaimer-title-color;
      margin: 0;
    }
  }
  
  .disclaimer-text {
    text-align: center;
    margin-bottom: 24px;
    
    .disclaimer-description {
      font-size: 14px;
      color: $disclaimer-description-color;
      line-height: 1.6;
      max-width: 600px;
      margin: 0 auto;
    }
  }
}

.signature-section {
  .signature-label {
    text-align: center;
    font-size: 14px;
    font-weight: 600;
    color: $signature-label-color;
    margin-bottom: 16px;
    
    .required-asterisk {
      color: $required-asterisk-color;
    }
  }
  
  .signature-pad-container {
    display: flex;
    justify-content: center;
    margin-bottom: 16px;
    width: 100%;
    max-width: 400px;
    margin-left: auto;
    margin-right: auto;
    
    @media (max-width: $breakpoint-mobile) {
      max-width: 100%;
    }
    
    .signature-pad {
      border: 1px solid $signature-pad-border;
      border-radius: 8px;
      background: $signature-pad-bg;
      width: 100%;
      max-width: 100%;
      
      @media (max-width: $breakpoint-mobile) {
        height: 150px;
      }
    }
  }
  
  .signature-actions {
    display: flex;
    justify-content: center;
  }
}
</style>
